import { render } from "./ImageActions.vue?vue&type=template&id=304b2bde&ts=true"
import script from "./ImageActions.vue?vue&type=script&lang=ts"
export * from "./ImageActions.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1205619327/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__